<template>
  <el-dialog
    :visible.sync="visible"
    title="监护人信息"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      ref="dataForm"
      :rules="selfdataRule"
      :model="selfform"
      label-width="120px"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="姓名" prop="realName">
            <el-input v-model="selfform.realName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号" prop="idnumber">
            <el-input
              v-model="selfform.idnumber"
              @blur="idnumchange"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="selfform.phone"></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="密码" prop="password">
            <el-input v-model="selfform.password" show-password></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="居住地址" prop="allAddress">
            <el-cascader
              ref="myCascader"
              :props="props"
              v-model="selfform.allAddress"
              @change="changeAdress"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="detailedAddress">
            <el-input v-model="selfform.detailedAddress"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="selfform.email"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="selfform.sex">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group> </el-form-item
        ></el-col>

        <el-col :span="12">
          <el-form-item label="民族" prop="nation">
            <el-input v-model="selfform.nation"></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="政治面貌" prop="politics">
            <el-select v-model="selfform.politics" placeholder="请选从事职业">
              <el-option
                :label="item"
                :value="item"
                :key="item"
                v-for="item in politicsList"
              ></el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="从事职业" prop="profession">
            <el-select v-model="selfform.profession" placeholder="请选从事职业">
              <el-option
                :label="item"
                :value="item"
                :key="item"
                v-for="item in professionList"
              ></el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="服务类型" prop="publishId">
            <el-select
              v-model="selfform.publishId"
              multiple
              placeholder="请选组织类型"
            >
              <el-option
                :label="item.typeName"
                :value="item.id"
                :key="item.id"
                v-for="item in typeList"
              ></el-option>
            </el-select> </el-form-item
        ></el-col>

        <el-col :span="12"
          ><el-form-item label="所属志愿服务队" prop="type">
            <el-select
              v-model="selfform.organizationId"
              placeholder="请选组织/机构"
            >
              <el-option
                :label="item.organizationName"
                :value="item.id"
                :key="item.id"
                v-for="item in typeList2"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="个人简介" prop="introduction">
            <el-input
              type="textarea"
              v-model="selfform.introduction"
            ></el-input>
          </el-form-item>
        </el-col>
        
        
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="onSubmit">确认</el-button>
    </template>
  </el-dialog>
</template>

<script>
let validatorrealName = (rule, value, callback) => {
  var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
    regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
  if (!value.trim()) {
    return callback(new Error("必填项不能为空"));
  }
  if (regEn.test(value) || regCn.test(value)) {
    return callback(new Error("名称不能包含特殊字符"));
  } else {
    callback();
  }
};
let validatorID = (rule, value, callback) => {
  var regEn = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (!value.trim()) {
    return callback(new Error("必填项不能为空"));
  }
  if (!regEn.test(value)) {
    return callback(new Error("身份证格式不正确"));
  } else {
    callback();
  }
};
let validatorphone = (rule, value, callback) => {
  var regEn = /^[1][3,5,7,8][0-9]{9}$/;
  if (!value.trim()) {
    return callback(new Error("必填项不能为空"));
  }
  if (!regEn.test(value)) {
    return callback(new Error("手机号格式不正确"));
  } else {
    callback();
  }
};
export default {
  data() {
    let That = this;
    return {
      visible: false,
      selfform: {
        organizationId: "",
        detailedAddress: "",
        email: "",
        header: "",
        idnumber: "",
        introduction: "",
        nation: "",
        nickname: "",
        type: "",
        password: "",
        phone: "",
        politics: "",
        profession: "",
        publishId: [],
        realName: "",
        sex: "",
        userName: "",
        type: 2,
        allAddress: [],
      },
      typeList: [],
      typeList2: [],
      professionList: ["行政单位", "事业单位", "企业", "其它"],
      politicsList: ["中共党员", "民主党派", "群众", "其它"],
      innerVisible: false,
      selfdataRule: {
        realName: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
          {
            validator: validatorrealName,
            trigger: "blur",
          },
        ],
        idnumber: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
          {
            validator: validatorID,
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "必填项不能为空", trigger: "blur" },

          {
            validator: validatorphone,
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        allAddress: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        email: [
          { required: false, message: "必填项不能为空", trigger: "blur" },
        ],
        sex: [{ required: true, message: "必填项不能为空", trigger: "change" }],
        nation: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        politics: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        profession: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        publishId: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
      },
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          if (level == 0) {
            var params = {
              code: "",
              level: "1",
            };
          } else {
            var params = {
              code: node.value,
              level: level + 1,
            };
          }
          That.$http
            .get(
              `City/city/getAllCity2?code=${params.code}&level=${params.level}`
            )
            .then((res) => {
              if (res.data.code == 0) {
                const nodes = res.data.data.map((item) => ({
                  value: item.criCode,
                  label: item.criName,
                  leaf: parseInt(item.criLevel) - 1 >= 2,
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }
            });
        },
      },
    };
  },
  computed: {},
  methods: {
    changeAdress(value) {
      console.log(
        this.$refs["myCascader"].inputValue,
        this.selfform.allAddress
      );
    },
    idnumchange() {
      var regEn = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!this.selfform.idnumber.trim() || !regEn.test(this.selfform.idnumber))
        return false;
      console.log(this.discriCard(this.selfform.idnumber));
      if (this.discriCard(this.selfform.idnumber) < 16) {
        this.$confirm("监护人必须年满18周岁", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
          .then(async () => {})
          .catch(() => {});
      }
    },
    discriCard(UUserCard) {
      (UUserCard + "").substring(6, 10) +
        "-" +
        (UUserCard + "").substring(10, 12) +
        "-" +
        (UUserCard + "").substring(12, 14);
      //获取年龄
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      var day = myDate.getDate();
      var age = myDate.getFullYear() - (UUserCard + "").substring(6, 10) - 1;
      if (
        (UUserCard + "").substring(10, 12) < month ||
        ((UUserCard + "").substring(10, 12) == month &&
          (UUserCard + "").substring(12, 14) <= day)
      ) {
        age++;
      }
      return age;
    },
    init() {
      this.visible = true;
      this.$nextTick(() => {
        if (!this.selfform.idnumber) {
          this.$refs["dataForm"].resetFields();
        }
      });
    },
    // 表单提交
    onSubmit: function () {
      this.$refs["dataForm"].validate((valid) => {
        if (!valid) {
          return false;
        }

        this.visible = false;
        this.$emit("guardianfrom", this.selfform);
      });
    },
  },
};
</script>
<style >
p {
  font-size: 16px;
  line-height: 28px;
}
</style>
